import React from 'react';
import { Link } from '@tanstack/react-router';
import { ChevronRight } from '../../icons/Icon';
import { NotificationBell } from '@/features/notifications/NotificationBell';

export type BreadcrumbItem = {
  label: string;
  to?: string;
};

export function Topbar({
  crumbs,
  title,
  subtitle,
  actions,
  banner,
}: {
  crumbs?: BreadcrumbItem[];
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  banner?: React.ReactNode;
}) {
  return (
    <>
      <div className="topbar">
        <div style={{ minWidth: 0, flex: 1 }}>
          {crumbs && crumbs.length > 0 && (
            <nav aria-label="Breadcrumb">
              <ol className="crumbs">
                {crumbs.map((crumb, i) => {
                  const isLast = i === crumbs.length - 1;
                  return (
                    <li key={`${crumb.label}:${crumb.to ?? ''}`} className="crumb">
                      {i > 0 && (
                        <span className="sep" aria-hidden="true">
                          <ChevronRight size={11} />
                        </span>
                      )}
                      {isLast || !crumb.to ? (
                        <span
                          className={isLast ? 'crumb-current' : undefined}
                          aria-current={isLast ? 'page' : undefined}
                          title={isLast ? crumb.label : undefined}
                        >
                          {crumb.label}
                        </span>
                      ) : (
                        <Link to={crumb.to} className="crumb-link">
                          {crumb.label}
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ol>
            </nav>
          )}
          {typeof title === 'string' ? (
            <h1
              className="display"
              style={{
                fontSize: 22,
                fontWeight: 700,
                color: 'var(--ink-900)',
                lineHeight: 1.1,
                marginBottom: subtitle ? 4 : 0,
              }}
            >
              {title}
            </h1>
          ) : (
            <div style={{ marginBottom: subtitle ? 4 : 0 }}>{title}</div>
          )}
          {subtitle && (
            <div style={{ fontSize: 13, color: 'var(--ink-500)' }}>{subtitle}</div>
          )}
        </div>
        <div className="topbar-actions">
          {actions}
          {/* App-wide notification bell — rendered by the shared Topbar so every
              chromed page gets the live badge + dropdown without repeating it.
              The bell's queries are gated on an access token, so unauthed
              frames fire no request. */}
          <NotificationBell />
        </div>
      </div>
      {banner}
    </>
  );
}
